"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SvgComponent(props, svgRef) {
  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef
  }, props), {}, {
    children: [(0, _jsxRuntime.jsx)("defs", {
      children: (0, _jsxRuntime.jsx)("path", {
        d: "M7 0a6 6 0 010 12 .672.672 0 01-.67-.674c0-.372.3-.674.67-.674a4.645 4.645 0 003.219-1.288A4.632 4.632 0 0011.659 6 4.656 4.656 0 007 1.348a4.646 4.646 0 00-3.296 1.364.668.668 0 01-.948-.003.677.677 0 01.003-.953A5.982 5.982 0 017 0zM2.477 3.103a.676.676 0 01.314.899 4.653 4.653 0 002.355 6.267.676.676 0 01-.017 1.245.669.669 0 01-.514-.007 6 6 0 01-3.033-8.088.669.669 0 01.895-.316zM7 2.436c.37 0 .67.302.67.674 0 .373-.3.675-.67.675A2.218 2.218 0 004.779 6c0 1.223.993 2.216 2.221 2.216.37 0 .67.301.67.674 0 .372-.3.674-.67.674a3.563 3.563 0 010-7.128zm2.172.74c.87.67 1.39 1.704 1.39 2.824a3.561 3.561 0 01-1.37 2.81.668.668 0 01-.94-.12.677.677 0 01.117-.945A2.208 2.208 0 009.221 6a2.21 2.21 0 00-.864-1.755.677.677 0 01-.125-.944.668.668 0 01.94-.126v.001z",
        id: "advanced__a"
      })
    }), (0, _jsxRuntime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [(0, _jsxRuntime.jsx)("path", {
        d: "M8 2a6 6 0 010 12 .672.672 0 01-.67-.674c0-.372.3-.674.67-.674a4.645 4.645 0 003.219-1.288A4.632 4.632 0 0012.659 8 4.656 4.656 0 008 3.348a4.646 4.646 0 00-3.296 1.364.668.668 0 01-.948-.003.677.677 0 01.003-.953A5.982 5.982 0 018 2zM3.477 5.103a.676.676 0 01.314.899 4.653 4.653 0 002.355 6.267.676.676 0 01-.017 1.245.669.669 0 01-.514-.007 6 6 0 01-3.033-8.088.669.669 0 01.895-.316zM8 4.436c.37 0 .67.302.67.674 0 .373-.3.675-.67.675A2.218 2.218 0 005.779 8c0 1.223.993 2.216 2.221 2.216.37 0 .67.301.67.674 0 .372-.3.674-.67.674a3.563 3.563 0 010-7.128zm2.172.74c.87.67 1.39 1.704 1.39 2.824a3.561 3.561 0 01-1.37 2.81.668.668 0 01-.94-.12.677.677 0 01.117-.945A2.208 2.208 0 0010.221 8a2.21 2.21 0 00-.864-1.755.677.677 0 01-.125-.944.668.668 0 01.94-.126v.001z",
        fillRule: "nonzero"
      }), (0, _jsxRuntime.jsxs)("g", {
        transform: "translate(1 2)",
        children: [(0, _jsxRuntime.jsx)("mask", {
          id: "advanced__b",
          fill: "currentColor",
          children: (0, _jsxRuntime.jsx)("use", {
            xlinkHref: "#advanced__a"
          })
        }), (0, _jsxRuntime.jsx)("path", {
          fill: "currentColor",
          fillRule: "nonzero",
          mask: "url(#advanced__b)",
          d: "M-2-3h18v18H-2z"
        })]
      })]
    })]
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent);
var _default = ForwardRef;
exports["default"] = _default;
//# sourceMappingURL=Advanced.js.map